import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AuthGuard } from './AuthGuard/auth-guard.service'
import { AppRoutingModule } from './app-routing.module';
import { AdminLeedsModule } from '../admin-leeds/admin-leeds.module'
import { AppComponent } from './app.component';
import { PedidoComponent } from './component/pedido/pedido.component';
import { SincronismoComponent } from './component/sincronismo/sincronismo.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatIconModule, MatInputModule, MatTabsModule, MatDatepickerModule, MAT_DATE_LOCALE, DateAdapter,
  MatNativeDateModule, MatButtonModule, MatSidenavModule, MatDividerModule, MatExpansionModule,
  MatToolbarModule, MatProgressBarModule, MatMenuModule, MatRadioModule, MatOptionModule, MatSelectModule,
  MatListModule, MatAutocompleteModule, MatFormFieldModule, MatDialogModule, MatSnackBarModule, MatCheckboxModule,
  MatPaginatorModule, MatBadgeModule
} from '@angular/material';

import { DxDataGridModule, DxButtonModule, DxLoadIndicatorModule, DxPopoverModule, DxLoadPanelModule, DxRangeSelectorModule, DxGalleryModule } from 'devextreme-angular';
import { ConfirmDialogComponent } from './component/confirm-dialog/confirm-dialog.component';
import { LoginComponent } from './component/login/login.component';
import { SomentenumeroDirective } from './directive/somentenumero.directive';
import { CadUsuarioComponent } from './component/cad-usuario/cad-usuario.component';
import { CadProdutoComponent } from './component/cad-produto/cad-produto.component';
import { CadVendedorComponent } from './component/cad-vendedor/cad-vendedor.component';
import { NgxCurrencyModule } from "ngx-currency";
import { Ng2BRPipesModule } from 'ng2-brpipes';
import { HomeClienteComponent } from './component/home-cliente/home-cliente.component';
import { ConsultarPedidoComponent } from './component/consultar-pedido/consultar-pedido.component';
import { CadBaseComponent } from './component/cad-base/cad-base.component';
import { ModalComponent } from './component/modal/modal.component';
import { InstrucoesImportacaoComponent } from './component/instrucoes-importacao/instrucoes-importacao.component';
import { LeedsComponent } from './component/leeds/leeds.component'
import { LeedsTermosComponent } from './component/leeds-termos/leeds-termos.component';
import { LeedsDistribuidorComponent } from './component/leeds-distribuidor/leeds-distribuidor.component';
import { AdminLeedsComponent } from './component/admin-leeds/admin-leeds.component';
import { EstadoCidadeComponent } from './component/estado-cidade/estado-cidade.component';

@NgModule({
  declarations: [
    AppComponent,
    PedidoComponent,
    SincronismoComponent,
    ConfirmDialogComponent,
    LoginComponent,
    SomentenumeroDirective,
    CadUsuarioComponent,
    CadProdutoComponent,
    CadVendedorComponent,
    HomeClienteComponent,
    ConsultarPedidoComponent,
    CadBaseComponent,
    ModalComponent,
    InstrucoesImportacaoComponent,
    LeedsComponent,
    LeedsTermosComponent,
    LeedsDistribuidorComponent,
    AdminLeedsComponent,
    EstadoCidadeComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatDividerModule,
    MatProgressBarModule,
    MatIconModule,
    FormsModule,
    AdminLeedsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTabsModule,
    MatExpansionModule,
    NgxCurrencyModule,
    Ng2BRPipesModule,
    DxLoadIndicatorModule,
    DxDataGridModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxRangeSelectorModule,
    MatSelectModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatBadgeModule,
    DxPopoverModule,
    DxGalleryModule
  ],
  entryComponents: [ConfirmDialogComponent],
  providers: [AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
